export default __webpack_public_path__ + "static/media/MusicalIntruments_07.32d3d878.png";